var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"history-item"},[_c('div',{staticClass:"history-item-date ms-help"},[_vm._v("\n    "+_vm._s(_vm.parseDateTime(_vm.action.time))+"\n  ")]),_c('div',{staticClass:"history-item-info ms-text"},[_c('div',{staticClass:"histy-item-title"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.action.user_string)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }